<template>
  <div>
    <div class="video">
      <!--      <img v-if="data.value5 === '1'" src="../../../assets/detail/no-video-list.png" alt="">-->
      <!--      预告-->
      <img v-if="(data.value5 === '1' || data.value5 === '0') && !videoUrl"
           src="../../../assets/detail/live-foreshow.png" alt="">

      <video v-if="data.value5 === '0' && videoUrl" id="media" controls :poster="videoPoster" x5-playsinline=""
             playsinline="" webkit-playsinline=""
             :src="videoUrl"></video>
      <div v-if="data.value5 === '1' && videoUrl" id="J_prismPlayer" style="width: 100%;height: 100%"></div>
    </div>
  </div>
</template>

<script>
import {Toast} from "vant";

export default {
  name: "DetailVideo",
  props: {
    data: {
      type: Object,
      default: () => ({
        value5: '0'
      })
    },
    // videoPoster: String,
    videoUrl: {
      type: String,
      default: ''
    },
     videoPoster: {
      type: String,
      default: ''
    },
    uaOutput: {
      type: String,
      default: navigator.userAgent.toLowerCase()
    },
  },
  data() {
    return {
      num: 0,
      player: null
    }
  },
  mounted() {
    if (this.data.value5 === '1' && this.videoUrl) {
      this.playerInit()
    }
  },
  methods: {
    playerInit() {
      debugger
      let url = this.videoUrl
      let image=this.data.image
      if (this.isMobile() || /macintosh|mac os x/i.test(navigator.userAgent)) {
        url = this.videoUrl.replace('https', 'http')
      }
// 阿里云H5播放器跨域问题
      if(url.indexOf(".vzan.com")!=-1){
        url = this.videoUrl.replace('http', 'https')
      }

      this.player = new Aliplayer({
            "id": "J_prismPlayer",
            "source": url,
            "width": "100%",
            "height": "100%",
            "autoplay": false,
            "isLive": true,
            "rePlay": false,
            "playsinline": true,
            "preload": false,
            "controlBarVisibility": "click",
            "showBarTime": 5000,
            "useH5Prism": true,
            "cover":image,
            "skinLayout": [
              {
                "name": "bigPlayButton",
                "align": "blabs",
                "x": 30,
                "y": 80
              },
              {
                "name": "errorDisplay",
                "align": "tlabs",
                "x": 0,
                "y": 0
              },
              {
                "name": "infoDisplay"
              },
              {
                "name": "controlBar",
                "align": "blabs",
                "x": 0,
                "y": 0,
                "children": [
                  {
                    "name": "liveDisplay",
                    "align": "tlabs",
                    "x": 15,
                    "y": 6
                  },
                  {
                    "name": "fullScreenButton",
                    "align": "tr",
                    "x": 10,
                    "y": 10
                  },
                  {
                    "name": "volume",
                    "align": "tr",
                    "x": 5,
                    "y": 10
                  }
                ]
              }
            ]
          }, function (player) {
            console.log("The player is created");
          }
      )
      setInterval(() => {
        console.log(this.player.getStatus());
      }, 1000)
    },
    isMobile() {
      let flag = navigator.userAgent.toLowerCase().match(/(phone|pad|pod|iphone|ipod|ios|ipad|android|mobile|blackberry|mqqbrowser|juc|fennec|wosbrowser|browserng|webos|symbian)/i)
      return flag ? flag.index : false;
    },
  },
  watch: {
    videoUrl() {
      this.num++
    }
  }
}
</script>

<style lang="scss" scoped>
.video {
  height: 422px;

  img {
    width: 100%;
  }

  video {
    width: 100%;
    height: 422px;
  }

  #J_prismPlayer {
    width: 100%;
    height: 100%;
  }

  // .video-js .vjs-big-play-button{
  //       font-size: 0.5rem;
  //       width: 1.5rem;
  //       height: 0.8rem;
  //       line-height: 0.75rem;
  //       top: 1.6rem;
  //       left: 3rem;
  //   }
}
</style>
